import ReporteStockUpdate from './ReporteStockUpdate'
export {ReporteStockUpdate}
export default ReporteStockUpdate
